module.exports = __webpack_public_path__ + "static/media/slider_study.e13610ee.jpg";